var _path, _g, _path2, _g2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2156_26698",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 8,
    width: 20,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00037 8.79492H22V22.5389H2.00037V8.79492Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2156_26698)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5654 22.5389H6.43537C3.99037 22.5389 2.00037 20.5499 2.00037 18.1039V13.2289C2.00037 10.7839 3.99037 8.79492 6.43537 8.79492H7.36837C7.78237 8.79492 8.11837 9.13092 8.11837 9.54492C8.11837 9.95892 7.78237 10.2949 7.36837 10.2949H6.43537C4.81637 10.2949 3.50037 11.6109 3.50037 13.2289V18.1039C3.50037 19.7229 4.81637 21.0389 6.43537 21.0389H17.5654C19.1834 21.0389 20.5004 19.7229 20.5004 18.1039V13.2199C20.5004 11.6069 19.1884 10.2949 17.5764 10.2949H16.6334C16.2194 10.2949 15.8834 9.95892 15.8834 9.54492C15.8834 9.13092 16.2194 8.79492 16.6334 8.79492H17.5764C20.0154 8.79492 22.0004 10.7799 22.0004 13.2199V18.1039C22.0004 20.5499 20.0104 22.5389 17.5654 22.5389",
    fill: "#062A41"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2156_26698",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 2,
    width: 2,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 2H12.75V15.5409H11.25V2Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2156_26698)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.541C11.586 15.541 11.25 15.205 11.25 14.791V2.75C11.25 2.336 11.586 2 12 2C12.414 2 12.75 2.336 12.75 2.75V14.791C12.75 15.205 12.414 15.541 12 15.541",
    fill: "#062A41"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08496 6.42902C8.89396 6.42902 8.70196 6.35602 8.55596 6.21002C8.26296 5.91802 8.26096 5.44402 8.55396 5.15002L11.469 2.22202C11.75 1.93902 12.25 1.93902 12.531 2.22202L15.447 5.15002C15.739 5.44402 15.738 5.91802 15.445 6.21002C15.151 6.50202 14.677 6.50202 14.385 6.20802L12 3.81402L9.61596 6.20802C9.46996 6.35602 9.27696 6.42902 9.08496 6.42902",
    fill: "#062A41"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBg);
export default __webpack_public_path__ + "static/media/uploadBG.2d21ab2270458e23504d51ebdc9af882.svg";
export { ForwardRef as ReactComponent };